/** @jsxRuntime classic */
/** @jsx jsx */
import React, { Component } from 'react';
import { jsx, css } from '@emotion/core';

import A from '../../../shared/Anchor/Anchor';
import ItemSlider from '../../../shared/ItemSlider/ItemSlider';
import ProductThumbnail from '../../../shared/ProductThumbnail/ProductThumbnail';
import {
  primary_s98_l83,
  primary_light,
  primary_s15_l20,
} from '../../../shared/lib/colors';

import './LatestBestSellers.scss';

class LatestBestSellers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: 'bestSellers',
    };
  }

  changeTab = selected => event => {
    event.preventDefault();
    this.setState({
      selected: selected,
    });
  };

  render() {
    const { selected } = this.state;
    const {
      primaryColor,
      secondaryColor,
      uiVariantMenu,
      uiVariantThumbnail,
    } = this.props;

    const liStyle = css`
      &.variant-1 {
        a {
          background-color: ${primary_light(primaryColor)};
          border-radius: 12px;
        }
        &:focus,
        &:hover,
        &.active {
          a {
            background-color: ${primary_s98_l83(secondaryColor)};
          }
        }
      }

      &.variant-2 {
        a {
          color: ${primaryColor};
          border: 1px solid ${primaryColor};
        }
        &:focus,
        &:hover,
        &.active {
          a {
            color: #fff;
            background-color: ${primaryColor};
          }
        }
      }

      &.variant-3 {
        a {
          color: ${primary_s15_l20(primaryColor)};
          text-transform: uppercase;
        }
        &:focus,
        &:hover,
        &.active {
          a {
            color: ${primaryColor};
          }
        }
      }
    `;

    return (
      <div className="container">
        <div className="latest-best-sellers">
          <ul className="nav nav-pills">
            <li
              role="presentation"
              className={`variant-${uiVariantMenu} ${
                selected === 'bestSellers' ? 'active' : ''
              }`}
              css={liStyle}
            >
              <A href="#" onClick={this.changeTab('bestSellers')}>
                Più venduti
              </A>
            </li>
            <li
              role="presentation"
              className={`variant-${uiVariantMenu} ${
                selected === 'latest' ? 'active' : ''
              }`}
              css={liStyle}
            >
              <A href="#" onClick={this.changeTab('latest')}>
                Ultimi arrivi
              </A>
            </li>
          </ul>

          <ItemSlider
            loading={this.props.loading}
            title="Prodotti"
            primaryColor={primaryColor}
            uiVariant={uiVariantThumbnail}
          >
            {this.props[selected].map(product => {
              return (
                <ProductThumbnail
                  key={product.id}
                  product={product}
                  list="Latest/Bestsellers slider"
                />
              );
            })}
          </ItemSlider>
        </div>
      </div>
    );
  }
}

export default LatestBestSellers;
